import { render, staticRenderFns } from "./legal-stop-case-manage.vue?vue&type=template&id=481c68cf&scoped=true"
import script from "./legal-stop-case-manage.vue?vue&type=script&lang=ts"
export * from "./legal-stop-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c68cf",
  null
  
)

export default component.exports